import React from "react";
import { Navbar } from './Navbar';

export default () =>
  <div className="NotFound">
    <Navbar />
    <h3 style={{marginTop: "150px", textAlign: "center"}}>Sorry, page not found!</h3>
  </div>;
